import { useCallback, useEffect, useMemo, useState } from "react";
import UserService from "services/UserService";
import toastMessages from "stores/toastMessages";
import { Guid } from "@/types";

export default function useAllUsers(autofetch: boolean) {
    const [users, setUsers] = useState<{ id: Guid, mail: string }[] | null>(null)

    const fetchUsers = useCallback(async () => {
        try {
            const resp = await UserService.getAllUserEmails()
            setUsers(resp)
        } catch(e) {
            toastMessages.showSystemError()
        }
    }, [])

    useEffect(() => {
        if (!autofetch) return
        fetchUsers()
    }, [autofetch, fetchUsers])

    const usersSelectOptions = useMemo(() => users?.map(user => ({
        label: user.mail,
        value: user.id,
    })), [users])

    return {
        users,
        fetchUsers,
        usersSelectOptions,
    }
}
